export default {
  handleDocumentContainer: {
    title: 'Ein Angebot anhängen',
    text: 'Legen Sie uns einen Kostenvoranschlag von einem Handwerker Ihrer Wahl vor. Dieser wird von unserer technischen Abteilung überprüft, die ihn bestätigt oder sich bei Bedarf mit Ihnen in Verbindung setzt.',
    billmaSolution: {
      title: 'Immobilienschäden',
      solution: 'Lösung: Meinen eigenen Handwerker auswählen',
      text1: 'Fügen Sie jetzt den Kostenvoranschlag Ihres Handwerkers zur Analyse bei.',
      text2: 'Durch die Übermittlung Ihrer Dokumente stimmen Sie zu, dass diese manuell oder durch einen Algorithmus analysiert werden.',
      text3: 'Kostenvoranschlag:',
      uploadBtn: 'Dokument hinzufügen'
    },
    actions: {
      primary: 'Weiter'
    },
    documentUploadStep: {
      actions: {
        primary: 'Dokument anhängen'
      }
    },
    icrModal: {
      title: 'Herunterladen von Dateien',
      text1: 'Die Dateien werden gerade verarbeitet. Bitte warten Sie weiter.',
      text2: 'Der Vorgang kann einige Minuten dauern.',
      text3: 'Wir verarbeiten Ihre Dokumente. Innerhalb weniger Minuten werden wir Ihre Entschädigung bestätigen.'
    },
    deleteModal: {
      title: 'Dokument löschen?',
      text: 'Das Dokument „{name}“ wird gelöscht und nicht zur Analyse gesendet.',
      confirm: 'Löschen',
      cancel: 'Abbrechen',
      error: 'Das Dokument konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.'
    }
  }
}
